<template>
  <div class="kydt">
    <div>
      <div class="title1" v-show="showList">现任领导</div>
      <div class="sub-title" v-show="showList">{{ time }}</div>
    </div>
    <listUserThree :columnId="column_id" @detail="detail" v-if="showList"></listUserThree>
    <detailVue :articleId="article_id" v-if="!showList"></detailVue>
  </div>
</template>
<script>
import detailVue from '../../components/detail.vue';
// import listFourVue from '../../components/listFour.vue';
import listUserThree from '../../components/listUserThree.vue';
export default {
  components: {
    listUserThree,
    detailVue
  },
  data() {
    return {
      showList: true,
      column_id: '',
      article_id: '',
      time: "",
    }
  },
  created() {
    this.column_id = this.$route.query.column_id
    let _this = this
    this.$common.noLoginCallUrl('/api/cp-cms/site/info/getInfoPage', {
      column_id: this.column_id,
      pageNo: 1,
      pageCount: 1
    },
      function (res) {
        if (res.code == '000000' && res.data && res.data.data && res.data.data.length > 0) {
          console.log("time", res.data.data[0].publish_time)
          _this.time = res.data.data[0].publish_time
        } else {
          _this.$message.warning(res.msg)
        }
      })
  },
  beforeDestroy() {
    // 在组件销毁前，移除 popstate 事件监听
    window.removeEventListener('popstate', this.onPopState)
  },
  methods: {
    onPopState(e) {

      if (this.showList == false) {
        this.showList = true
        // window.history.pushState(null, null, window.location.href)
      } else {
        window.removeEventListener('popstate', this.onPopState)
        //  window.history.go(-1)
        this.$router.replace({ path: '/' })
      }
    },
    detail(item) {
      if (item.redirection_address) {
        window.open(item.redirection_address);
      } else {
        this.article_id = item.article_id
        this.showList = false
      }
    }
  },
  mounted() {
    // 添加 popstate 事件监听
    window.history.pushState(null, null, window.location.href);
    window.addEventListener('popstate', this.onPopState);
  },
  watch: { // 监听，当路由发生变化的时候执行
    $route(to, from) {
      this.showList = true
    }
  }
};
</script>

<style lang="less" scoped>
.title1 {
  text-align: center;
  font-size: 22px;
  margin: 10px 0;
}

.sub-title {
  margin-top: 40px;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  color: #666;
}
</style>